<template>
    <span class="inline-block rounded-full w-1 h-1 bg-gray" />
</template>
